import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from 'i18next-chained-backend';
import XhrBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { Formaters } from "lib/Formaters";
import moment from "moment";
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/pt-br';
import { initReactI18next } from 'react-i18next';

//////////////////////////////////////////////////////////////////////////////////////////
const momentLanguages = ["en", "es", "pt", "pt-br"];
const knowLanguages = ["en", "en-US", "es", "es-ES", "pt", "pt-BR"];
const defaultLanguage = "pt-BR";
let i18FunctionsSet = false;
let localeBackendApiPath = "";

export function reloadloadI18nConfig(serverBackendApiPath: string) {
    localeBackendApiPath = serverBackendApiPath;
    i18n.reloadResources();
}

function setMomentLocale(locale: string) {
    var lang = locale.toLowerCase();
    if (!momentLanguages.includes(lang)) {
        if (lang.length > 2) lang = lang.substring(0, 2);
        if (!momentLanguages.includes(lang)) lang = defaultLanguage;
    }
    moment.locale(lang);
}

function loadI18nConfig() {
    i18n
        .use(detector)
        .use(Backend)
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            // have a common namespace used around the full app
            ns: ["core", "knowledge", "lms", "assessment", "award", "dashboard", "shared"],
            //
            fallbackLng: "pt",
            defaultNS: "core",
            partialBundledLanguages: true,
            debug: (process.env.NODE_ENV == "development"),
            returnNull: false,
            //
            interpolation: {
                escapeValue: false, // not needed for react!!
            },
            //
            backend: {
                backends: [
                    XhrBackend,
                    resourcesToBackend((language, namespace, callback) => {
                        import(`../locales/${namespace}/${language}/translations.json`)
                            .then((resources) => {
                                callback(null, resources);
                            })
                            .catch((error) => {
                                callback(error, null);
                            });
                    })
                ],
                backendOptions: [
                    {
                        // Server Side: resources do locatátio;
                        loadPath: () => {
                            return localeBackendApiPath === ""
                                ? "/locale-empty.json"
                                : `${(window as any)["localeBackendApiPath"]}/TenantLocales?ns={{ns}}&lang={{lng}}&hostname=${window.location.hostname}`;
                        }
                    }
                ]
            },
            //
            detection: {
                // order and from where user language should be detected
                order: ['querystring', 'navigator'],
            },
            //
            react: {
                useSuspense: true,
                bindI18n: 'languageChanged loaded',
                transEmptyNodeValue: '',
                transSupportBasicHtmlNodes: true,
                transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'p', 'span'],
            }
        }, (err, t) => {
            if (!i18FunctionsSet) {
                i18n.services.formatter?.add('lowercase', (value, lng, options) => {
                    return value.toLowerCase();
                });

                i18n.services.formatter?.add('uppercase', (value, lng, options) => {
                    return value.toUpperCase();
                });

                i18n.services.formatter?.add('capitalize', (value, lng, options) => {
                    return Formaters.capitalize(value);
                });

                i18n.services.formatter?.add('capitalize', (value, lng, options) => {
                    return Formaters.capitalizeAll(value);
                });

                i18n.services.formatter?.add('toFixed0', (value, lng, options) => {
                    return typeof (value) == "number" ? value.toFixed(0) : "";
                });

                i18n.services.formatter?.add('toFixed2', (value, lng, options) => {
                    return typeof (value) == "number" ? value.toFixed(2) : "";
                });

                i18n.services.formatter?.add('currency', (value, lng, options) => {
                    return typeof (value) == "number" ? Formaters.currency(value) : "";
                });

                i18n.services.formatter?.add('relativeTime', (value, lng, options) => {
                    const dt = value instanceof Date ? value : new Date(value);
                    return Formaters.relativeTime(dt) ?? "";
                });

                i18n.services.formatter?.add('dateL', (value, lng, options) => {
                    const dt = value instanceof Date ? value : new Date(value);
                    return Formaters.localeDate(dt) ?? "";
                });

                i18n.services.formatter?.add('dayMonth', (value, lng, options) => {
                    const dt = value instanceof Date ? value : new Date(value);
                    return Formaters.dayMonth(dt) ?? "";
                });

                i18n.services.formatter?.add('hm', (value, lng, options) => {
                    const dt = value instanceof Date ? value : new Date(value);
                    return Formaters.localeTime(dt) + "h";
                });

                /////////////////////

                i18n.on('languageChanged', function (lng) {
                    setMomentLocale(lng);
                    window.uiLanguage = lng;
                });

                /////////////////////
                i18FunctionsSet = true;
            }

            if (!knowLanguages.includes(i18n.language)) {
                i18n.changeLanguage(defaultLanguage);
            }
            else {
                setMomentLocale(i18n.language);
            }
            /////////////////////
        });
}

loadI18nConfig();

export default i18n;
